var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Content',{attrs:{"is-fin":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }